
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/a9d6aff03562300b57162884cb61551b/aea8bd7be2b5edb3fb17a566ccc28baa.png" 
                alt="BBD Financial Logo"
                className="h-9 brightness-0 invert"
              />
              <span className="text-lg font-bold">ISO Decline Program</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Trusted broker referral portal with 15+ years of experience turning bad leads, delinquencies, and judgments into real commissions.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-blue-600 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-sm text-white"></i>
              </a>
              <a
                href="#"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-blue-600 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-sm text-white"></i>
              </a>
              <a
                href="#"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-blue-600 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-sm text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-gray-400 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#services"
                  className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="#how-it-works"
                  className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer"
                >
                  How It Works
                </a>
              </li>
              <li>
                <a
                  href="#testimonials"
                  className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer"
                >
                  Testimonials
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-gray-300 hover:text-blue-400 text-sm transition-colors cursor-pointer"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-gray-400 mb-4">
              Services
            </h4>
            <ul className="space-y-3">
              <li className="text-gray-300 text-sm">Bad Lead Resolution</li>
              <li className="text-gray-300 text-sm">Delinquency Management</li>
              <li className="text-gray-300 text-sm">Judgment Recovery</li>
              <li className="text-gray-300 text-sm">Broker Referral Portal</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-xs">
              &copy; {new Date().getFullYear()} ISO Decline Program. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-gray-500 hover:text-gray-300 text-xs transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
